import { Injectable } from '@angular/core';
import { AuthUtil } from '../utils/auth.utils';
import { HttpClient } from '@angular/common/http';
import { AuthResponse } from '../models/interfaces/auth-response.interface';
import { environment } from '../../config/environments/environment';
import { Router } from '@angular/router';
import { AuthIdentityService } from './auth-identity.service';
import { LoginResultDto } from '../models/dto/login-result.dto';

@Injectable()
export class SignInService {
  constructor(
    private readonly http: HttpClient,
    private readonly authIdentityService: AuthIdentityService,
    private readonly authUtil: AuthUtil,
    private readonly router: Router
  ) { }

  async login(email: string, password: string): Promise<LoginResultDto> {
    const request = JSON.stringify({ email, password });
    const response = await this.http
      .post<AuthResponse>(`${environment.api.baseUrl}/auth/login`, request)
      .toPromise();

    this.authUtil.saveAccesToken(response.access_token);
    this.authUtil.saveRefreshToken(response.refreshToken);
    this.authUtil.saveIdentities(response.identities!);
    return await this.selectTenant(response);
  }

  async loginByPass(response: AuthResponse): Promise<LoginResultDto> {
    this.authUtil.saveAccesToken(response.access_token);
    this.authUtil.saveRefreshToken(response.refreshToken);
    this.authUtil.saveIdentities(response.identities!);

    return await this.selectTenant(response);
  }

  private async selectTenant(auth: AuthResponse): Promise<LoginResultDto> {
    const hasMultipleTenants = auth.identities && auth.identities.length > 1;
    
    if (hasMultipleTenants) {
      return {
        navigateTo: 'select-tenant',
      };
    } else {
      await this.authIdentityService.fetchAndSaveData(auth.identities![0]);
      return {
        navigateTo: 'news-list',
      };
    }
  }
}
